import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

const DiagnosisAccuracyStep: React.FC<StepComponentProps> = ({
                                                               formData,
                                                               updateFormData,
                                                               onNext,
                                                               onPrevious,
                                                               canGoBack,
                                                               canGoNext,
                                                               patientCaseType,
                                                               journey,
                                                             }) => {
  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleDiagnosisChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    updateFormData({diagnosisOk: value});
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h5 className="text-danger mb-4">Were the initial diagnosis accurate?</h5>
        <Row>
          <Col md="12">
            <div className="mb-4 p-3 bg-light rounded">
              {journey.patientCase?.motherSymptoms?.length > 0 && (
                <div className="mb-3">
                  <h6 className="text-primary">Symptoms For Mother</h6>
                  <div className="text-muted">
                    {journey.patientCase?.motherSymptoms?.map(symptom => symptom.enCondition).join(', ') || '-'}
                  </div>
                </div>
              )}

              {journey.patientCase?.babySymptoms?.length > 0 && (
                <div className="mb-3">
                  <h6 className="text-primary">Symptoms For Baby</h6>
                  <div className="text-muted">
                    {journey.patientCase?.babySymptoms?.map(symptom => symptom.enCondition).join(', ') || '-'}
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup name="diagnosisOk" required value={formData.diagnosisOk?.toString()}>
            <Row>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="diagnosisOk"
                    value="true"
                    onChange={handleDiagnosisChange}
                    className="radio-button-input"
                  />
                  Yes
                </Label>
              </Col>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="diagnosisOk"
                    value="false"
                    onChange={handleDiagnosisChange}
                    className="radio-button-input"
                  />
                  No
                </Label>
              </Col>
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={1}
            totalSteps={10}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default DiagnosisAccuracyStep;
